module.exports = __webpack_public_path__ + "static/img/about-main1.63f78cfd.png";